<!DOCTYPE html>
<ion-content>
  <div class="store-payment-wrapper">
    <div class="store-payment-top">
      <img src="assets/icon/back_arrow.png" alt="back arrow" class="back-ic" [class.back-ic-disabled]="creditPaymentInProgress" (click)="goBack()" />
      <h1 class="checkout-heading">{{ "store-payment.Checkout" | translate }}</h1>
      <p class="select-payment">{{ "store-payment.credit_purchase" | translate }}</p>
    </div>
    <div>
      <ion-card class="purchase-card">
        @if (creditCheckoutData?.checkout_description) {
          <p [innerHTML]="creditCheckoutData?.checkout_description"></p>
        } @else {
          <p class="purchase-heading">{{ creditCheckoutData?.lottery }}</p>
          @for (day of creditCheckoutData?.draw_day; track day) {
            <p class="purchase-content">
              {{ creditCheckoutData?.lines }} {{ "store-payment.lines_on" | translate }} {{ day | day }}
            </p>
          }
        }
      </ion-card>
    </div>
    <div class="payable-today-wrapper">
      <p class="payable-today">{{ "store-payment.use_credit" | translate }}</p>
      <p class="payable-today-amt">
        {{ currencySymbol }}{{ (creditCheckoutData?.int_price ? creditCheckoutData?.int_price?.[preferredCurrency] : creditCheckoutData?.price) | displayCurrency }}
      </p>
    </div>
    <div class="choose-btn">
      <button [disabled]="creditPaymentInProgress" (click)="onJoinClick()">
        @if (!spinnerAnimation) {
          <div>{{"store-product.Join" | translate }}</div>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
            </mat-progress-spinner>
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
      </button>
    </div>
    <p class="bottom-info">
      {{ "store-payment.Hatchster" | translate }}
    </p>
  </div>
</ion-content>
